import React from 'react';
import { styled } from '@mui/material';

import { TeamAnalyticsPieChart } from 'components/molecules/PieChart';
import { Box, Stack, Text } from 'shell/components';
import { useAuth } from 'contexts/auth';
import { useTask } from 'contexts/task';
import { WORKLOAD_POINTS } from 'utils/constants';

const TeamAnalytics = ({ size, ...rest }) => {
    const { auth } = useAuth();
    const { taskList, subtaskList } = useTask();

    const completedPoints = [...Object.values(taskList.all), ...Object.values(subtaskList)]
        .filter(({ active }) => active)
        .filter(({ status }) => status === 'completed')
        .reduce((acc, cur) => {
            return acc + WORKLOAD_POINTS[cur.workload];
        }, 0);
    const totalPoints = [...Object.values(taskList.all), ...Object.values(subtaskList)]
        .filter(({ active }) => active)
        .reduce((acc, cur) => {
            return acc + WORKLOAD_POINTS[cur.workload];
        }, 0);

    const percentage = totalPoints ? `${((completedPoints / totalPoints) * 100).toFixed()}%` : '0%';

    return (
        <Stack {...rest}>
            <CustomBox>
                <TeamAnalyticsPieChart completed={completedPoints} role={auth.role} total={totalPoints} />
                <PercentageStack alignItems={'center'}>
                    <Text component={'p'} variant={'h1'}>
                        {percentage}
                    </Text>
                    <Text align={'center'} variant={'p3'}>
                        of Task Points Completed
                    </Text>
                </PercentageStack>
            </CustomBox>
            <Stack alignItems={'center'} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <CompleteBox />
                    <Text variant={'p1'}>Complete</Text>
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <IncompleteBox />
                    <Text variant={'p1'}>Incomplete</Text>
                </Stack>
            </Stack>
        </Stack>
    );
};

const CustomBox = styled(Box)(({ theme }) => {
    return {
        position: 'relative',
        margin: theme.spacing(3, 0, 4),
    };
});

const PercentageStack = styled(Stack)(() => {
    return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    };
});

const CompleteBox = styled(Box)(({ theme }) => {
    return {
        borderRadius: '50%',
        width: '1rem',
        height: '1rem',
        background: theme.palette.ensightful.primary[500],
    };
});

const IncompleteBox = styled(Box)(({ theme }) => {
    return {
        borderRadius: '50%',
        width: '1rem',
        height: '1rem',
        background: theme.palette.ensightful.primary[100],
    };
});

export default TeamAnalytics;
